const IDENTITY_CONSOLE_ORIGIN = "https://id.sefket.dev";

export function identityConsoleUrl(): string {
  return `${IDENTITY_CONSOLE_ORIGIN}/console?product=workbench`;
}
